import { render, staticRenderFns } from "./TaskSingleProductPopup.vue?vue&type=template&id=4bb8e861&scoped=true&"
import script from "./TaskSingleProductPopup.vue?vue&type=script&lang=js&"
export * from "./TaskSingleProductPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskSingleProductPopup.vue?vue&type=style&index=0&id=4bb8e861&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8e861",
  null
  
)

export default component.exports